module.exports = __webpack_public_path__ + "static/media/S4_02.4d96f539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STAGE4strobe/S4_02.png
// module id = 200
// module chunks = 0